<div class="sidebar-filter drawers" role="region">
    <div role="tabpanel">
        <!-- Personas Section -->
        <div class="filter-section">
            <div
                class="panel-heading"
                [class.aria-selected]="isPanelOpen('personas')"
                (click)="togglePanel('personas')"
            >
                <h4 personaTooltip>personas</h4>
            </div>
            
            @if (isPanelOpen('personas')) {
            <div
                class="panel-content"
                role="tabpanel"
                [attr.aria-expanded]="isPanelOpen('personas')"
            >
                @for (persona of personas(); track persona.id) {
                <div class="filter-option">
                    <label [class.disabled]="isPersonaDisabled(persona.id)">
                        <input
                            type="checkbox"
                            [checked]="selectedPersonas().includes(persona.id)"
                            [disabled]="isPersonaDisabled(persona.id)"
                            (change)="toggleSelection(selectedPersonas, persona.id)"
                        />
                        {{ persona.name }}
                    </label>
                </div>
                }
            </div>
            }
        </div>

        <!-- Life Cycle Phases Section -->
        <div class="filter-section">
            <div
                class="panel-heading"
                [class.aria-selected]="isPanelOpen('lifeCyclePhases')"
                (click)="togglePanel('lifeCyclePhases')"
            >
                <h4>life cycle phases</h4>
            </div>
            
            @if (isPanelOpen('lifeCyclePhases')) {
            <div
                class="panel-content"
                role="tabpanel"
                [attr.aria-expanded]="isPanelOpen('lifeCyclePhases')"
            >
                @for (lifeCyclePhase of lifeCyclePhases(); track $index) {
                <div class="filter-option">
                    <label>
                        <input
                            type="checkbox"
                            [checked]="isLifeCyclePhaseSelected(lifeCyclePhase)"
                            (change)="toggleSelection(selectedLifeCyclePhases, lifeCyclePhase)"
                        />
                        {{ getLifeCyclePhaseName(lifeCyclePhase) }}
                    </label>
                </div>
                }
            </div>
            }
        </div>

        <!-- Future Features (Commented) -->
        <!-- 
        TODO: Uncomment when Product Teams filter is needed
        <div class="filter-section">
            <div
                class="panel-heading"
                role="tab"
                [class.aria-selected]="isPanelOpen('productTeams')"
                (click)="togglePanel('productTeams')"
            >
                <h4>product teams</h4>
            </div>
            
            @if (isPanelOpen('productTeams')) {
            <div
                class="panel-content"
                role="tabpanel"
                [attr.aria-expanded]="isPanelOpen('productTeams')"
            >
                @for (productTeam of productTeams(); track productTeam.id) {
                <div class="filter-option">
                    <label>
                        <input
                            type="checkbox"
                            [checked]="selectedProductTeams().includes(productTeam.id)"
                            (change)="toggleSelection(selectedProductTeams, productTeam.id)"
                        />
                        {{ productTeam.name }}
                    </label>
                </div>
                }
            </div>
            }
        </div>
        -->

        <!-- Tool Types Section -->
        <div class="filter-section">
            <div
                class="panel-heading"
                role="tab"
                [class.aria-selected]="isPanelOpen('toolTypes')"
                (click)="togglePanel('toolTypes')"
            >
                <h4>tool types</h4>
            </div>
            
            @if (isPanelOpen('toolTypes')) {
            <div
                class="panel-content"
                role="tabpanel"
                [attr.aria-expanded]="isPanelOpen('toolTypes')"
            >
                @for (toolType of toolTypes(); track toolType.id) {
                <div class="filter-option">
                    <label>
                        <input
                            type="checkbox"
                            [checked]="selectedToolTypes().includes(toolType.id)"
                            (change)="toggleSelection(selectedToolTypes, toolType.id)"
                        />
                        {{ toolType.name }}
                    </label>
                </div>
                }
            </div>
            }
        </div>
    </div>
    <!-- Actions Section -->
    <div class="filter-actions">
        <hr>
        <div class="actions mt-2">
            <button 
                type="button"
                class="secondary small btn-filter" 
                (click)="clearFilters()"
            >
                clear filters
            </button>
        </div>
    </div>
</div>